// Shared interfaces and logic for ChallengeTag
export interface ChallengeTagProps {
    level: 'global' | 'personal' | 'organization' | 'team';
    isEligible?: boolean;
    className?: string;
}

export interface TagConfig {
    emoji: string;
    label: string;
    bgColor: string;
    textColor: string;
    borderColor: string;
}

// Shared utility function
export const getTagConfig = (level: ChallengeTagProps['level']): TagConfig => {
    switch (level) {
        case 'global':
            return {
                emoji: '🌍',
                label: 'Global',
                bgColor: 'bg-blue-100',
                textColor: 'text-blue-800',
                borderColor: 'border-blue-200'
            };
        case 'personal':
            return {
                emoji: '👤',
                label: 'Personal',
                bgColor: 'bg-green-100',
                textColor: 'text-green-800',
                borderColor: 'border-green-200'
            };
        case 'organization':
            return {
                emoji: '🏢',
                label: 'Organization',
                bgColor: 'bg-purple-100',
                textColor: 'text-purple-800',
                borderColor: 'border-purple-200'
            };
        case 'team':
            return {
                emoji: '👥',
                label: 'Team',
                bgColor: 'bg-orange-100',
                textColor: 'text-orange-800',
                borderColor: 'border-orange-200'
            };
        default:
            return {
                emoji: '🎯',
                label: 'Challenge',
                bgColor: 'bg-gray-100',
                textColor: 'text-gray-800',
                borderColor: 'border-gray-200'
            };
    }
}; 